import styled from 'styled-components';

export const FooterElementWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    height: 100%;
    cursor: pointer;
`;
